export const masterChefAddress = '0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d'
export const bscsAddress = '0xbcb24afb019be7e93ea9c43b7e22bb55d5b7f45d'
export const wbnbAddress = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c'
